import { render, staticRenderFns } from "./WidgetFormDialog.vue?vue&type=template&id=db176e30&scoped=true&"
import script from "./WidgetFormDialog.vue?vue&type=script&lang=js&"
export * from "./WidgetFormDialog.vue?vue&type=script&lang=js&"
import style0 from "./WidgetFormDialog.vue?vue&type=style&index=0&id=db176e30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db176e30",
  null
  
)

export default component.exports